import { useTranslation } from "react-i18next";

import { FieldCheckbox } from "@/ui/field-checkbox";
import { FieldNumber } from "@/ui/field-number";
import { FieldText } from "@/ui/field-text";

import { SchemaBuilderExpression } from "../../schema-builder-expression";

import "./schema-builder-field-editor-expression.style.less";

export const EditorExpressionFields = () => {
  const { t } = useTranslation();

  return (
    <>
      <FieldText name="label" label={t(`schema:property.label`)} required />
      <FieldText name="description" label={t(`schema:property.description`)} />
      <div className="editor-expression-fields-inline">
        <FieldText name="model" label={t(`schema:property.model`)} required />
        <FieldNumber
          name="precision"
          label={t(`schema:property.precision`)}
          min={0}
          max={20}
        />
        <FieldText
          name="unit"
          label={t(`schema:property.unit`)}
          maxLength={30}
        />
      </div>
      <SchemaBuilderExpression name="expression" required />
      <FieldCheckbox name="readOnly" hidden />
    </>
  );
};
